(function() {
    var listTmpl = 
    '<tr>' +
        '<td>{{category}}</td>' +
        '<td class="board-tit">' +
            '<a href="{{url}}">' +
                '{{# if (flag != "") { #}}' +
                '<div class="flag-wrap bar-type">' +
                    '<span class="flag"><span class="blind">제품 상태</span>{{flag}}</span>' +
                '</div>' +
                '{{# } #}}' +
                '<p>{{title}}</p>' +
            '</a>' +
        '</td>' +
        '<td>{{date}}</td>' +
        '<td>{{view}}</td>' +
    '</tr>';
    
    var gubunTmpl = 
    	'{{#each (item, index) in gubunList}}' +
    		'{{# if (item.commonCodeName == "전체") { #}}' +
    		'<option value="">전체</option>' +
    		'{{# } else { #}}' +
    		'<option value="{{item.commonCodeId}}">{{item.commonCodeName}}</option>' +
    		'{{# } #}}' +
    	'{{/each}}';

    $(window).ready(function() {
    	var software = {            
            params: {},
            queryString: '',
            cateYn: false,
            init: function() {
                var self = this,
                    $contents = $('.contents.support');
                
                self.$searchWrap = $contents.find('.search-wrap');
                self.$deleteButton = $contents.find('.search-wrap .btn-delete');
                self.$pagination = $contents.find('.pagination');
                self.$resultWrap = $contents.find('.result-wrap');
                self.$sortsWrap = $contents.find('.sorting-wrap');
                self.$sortTotal = $contents.find('#count');
                self.$sortSelectWrap = $contents.find('.sort-select-wrap');
                self.$sortSelect = $contents.find('.ui_selectbox');
                self.$categorySelect = self.$sortSelect.filter('#category');
                self.$orderSelect = self.$sortSelect.filter('#orderType');
                self.$listWrap = $contents.find('.tb_row');
                self.$noData = $contents.find('.empty-row');
                self.$download = $contents.find('.addfile-wrap');
                self.$tab = $contents.find('.tabs-wrap-new');

                self.queryString = lgkorUI.getParameterByName('cate');
                self.params = {
                    'keyword': self.$searchWrap.find('input[type="text"]').val(),
                    'category': self.$sortSelect.filter('#category').vcSelectbox('value'),
                    'orderType': self.$sortSelect.filter('#orderType').vcSelectbox('value'),
                    'page': 1
                };
                

                if (!self.queryString) {
                    self.$resultWrap.attr('id', 'all').attr('aria-labelledby', 'all'); //웹접근성
                }
                
                self.$pagination.pagination();
                if (vcui.detect.isMobileDevice) {
                    self.$pagination.find('a').attr('role', 'button'); //웹접근성
                }
            
                self.bindEvent();
            },
            searchList: function() {
                var self = this,
                    url = self.$searchWrap.data('ajax');
                
                if(!!self.queryString){
                	url = url + "?cate=" + self.queryString;// + "&isM=N";
                }

                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, self.params, function(d) {
                    var html = '',
                        data = d.data.listData,
                        page = d.data.listPage;
	
                 	// BTOCSITE-49822 [홈페이지/고객지원] 검색창 "X 버튼" 개선 요청
                 	// BTOCSITE-64549 [모니터링 G][APP] 필터 조건에 따라 검색 페이지가 다시 로드되지만 검색창의 콘텐츠에는 X 버튼 사라지는 현상
                    self.$searchWrap.find('input[type="text"]').val(self.params['keyword']);
                    // BTOCSITE-69628 [모니터링 G][PC] 표시된 데이터가 없는 경우에도 입력에 "X" 아이콘이 나타남
                    self.$searchWrap.find('.ui_input_clearbutton').vcInputClearButton('changeVal', self.params['keyword']);
            
                    self.$sortTotal.html(page.totalCount);                    
                    self.$pagination.pagination('update', page);
                    self.$listWrap.find('tbody').find('tr').not( self.$noData).remove();

                    // 탭 선택 시 
					var gubun = d.gubunList;
					if(self.cateYn){
	                    if(gubun.length){
	                    	
	                    	gubun.unshift({'commonCodeName':'전체'});
	                    	var categoryHtml  = vcui.template(gubunTmpl,  {'gubunList': gubun});

	                    	self.$categorySelect.empty();
	                    	self.$categorySelect.html(categoryHtml);
	                    	
	                    	self.$categorySelect.prop('disabled', false);
	                    	self.$categorySelect.vcSelectbox('update');
	                    	$('.sort-select-wrap').filter('.category').show();
	                    	
		                	
						}else{
							$('.sort-select-wrap').filter('.category').hide();
	                    }
					}


                    if (data.length) {
                        data.forEach(function(item) {
                            html += vcui.template(listTmpl, item);
                        });
                        self.$listWrap.find('tbody').prepend(html);
                        self.$noData.hide();
                    } else {
                        self.$noData.show();
                    }
                   	self.cateYn = false;
                    lgkorUI.hideLoading();
                });
            },
            bindEvent: function() {
                var self = this;
                
                //탭 선택
                self.$tab.vcTab().on('tabchange', function(e, data) {
                	e.preventDefault();
                	var href = $(data.button).attr('href').replace("#", "");
                    self.queryString = href == 'all' ? '' : href;
                    
                	self.cateYn = true;
                    self.params = $.extend({}, self.params, {
                        'category': '',
                        'page': 1
                    });
                	
                    self.searchList();
                    //BTOCSITE-94858 [모니터링][웹앱 접근성 개선활동] 고객지원
                    self.$resultWrap.attr('id', href).attr('aria-labelledby', href).attr('aria-hidden', false).css('display', 'block').attr('tabindex', 0).focus();
                	self.$resultWrap.one('focusout', function (e) {
					    $(e.currentTarget).removeAttr('tabindex');
					});

            	});

                self.$listWrap.on('click', '.board-tit a', function() {
                    lgkorUI.historyBack(this);
                });

                self.$searchWrap.find('input[type="text"]').on('input', function() {
                    var val = $(this).val().trim();

                    if (val.length > 1) {
                        $('.search-error').hide();
                    }
                });

                self.$searchWrap.find('input[type="text"]').on('keyup', function(e) {
                    if (e.keyCode == 13) { 
                        self.$searchWrap.find('.btn-search').trigger('click');
                    }
                });
                

                
                self.$searchWrap.find('.btn-search').on('click', function() {
                    var val = self.$searchWrap.find('input[type="text"]').val().trim();

                    if (val.length > 1) {
                        self.params = $.extend({}, self.params, {
                            'keyword': val,
                            'page': 1
                        });
                        
                        $('.search-error').hide();

                        self.searchList();
                    } else if (val.length == 1) {
                        $('.search-error').show();
                    } else {
                        self.params = $.extend({}, self.params, {
                            'keyword': '',
                            'page': 1
                        });

                        self.searchList();

                        $('.search-error').hide();
                    }
                });

                //self.$sortSelect.on('change', function() {
                self.$sortSelect.filter('#orderType').on('change', function() {
                	self.params = $.extend({}, self.params, {
                        'category': self.$sortSelect.filter('#category').vcSelectbox('value'),
                        'orderType': self.$sortSelect.filter('#orderType').vcSelectbox('value'),
                        'page': 1
                    });
                    self.searchList();
                });
                
                self.$sortSelect.filter('#category').on('change', function() {
                	self.params = $.extend({}, self.params, {
                        'category': self.$sortSelect.filter('#category').vcSelectbox('value'),
                        'orderType': self.$sortSelect.filter('#orderType').vcSelectbox('value'),
                        'page': 1
                    });
                    self.searchList();
                });                

                $('.ui_selectbox').vcSelectbox().on('selectboxopen', function(e, sbox){
                    
                    lgkorUI.showAppBottomMenu(false);
                    lgkorUI.setEnableAppScrollBottomMenu(false);

                }).on('selectboxclose', function(e, sbox){

                    lgkorUI.showAppBottomMenu(true);
                    lgkorUI.setEnableAppScrollBottomMenu(true);
                });

                //모바일시
                $('#bottomSheet-category').on('click','a', function(e) {
                	e.preventDefault();
                	var value = $(this).data('value');
                    self.params = $.extend({}, self.params, {
                        'category': value,
                        'orderType': self.$sortSelect.filter('#orderType').vcSelectbox('value'),
                        'page': 1
                    });
                    self.searchList();
                });
                
                $('#bottomSheet-orderType').on('click','a', function(e) {
                	e.preventDefault();
                	var value = $(this).data('value');
                    self.params = $.extend({}, self.params, {
                        'category': self.$sortSelect.filter('#category').vcSelectbox('value'),
                        'orderType': value,
                        'page': 1
                    });
                    self.searchList();
                });                

                self.$pagination.on('pageClick', function(e) {
                    self.params = $.extend({}, self.params, {
                        'page': e.page
                    });
                    self.searchList();
                    window.scrollTo(0,0);
                    setTimeout (function(){
                    	//BTOCSITE-94858 [모니터링][웹앱 접근성 개선활동] 고객지원
	                    self.$resultWrap.find('.tb_row tbody tr:first-child a').focus();
                    }, 1000);
                });


            }
        }
        
        software.init();
    });
})();